import { render } from "./ContentPageList.vue?vue&type=template&id=c53cfe88&scoped=true"
import script from "./ContentPageList.vue?vue&type=script&lang=js"
export * from "./ContentPageList.vue?vue&type=script&lang=js"

import "./ContentPageList.vue?vue&type=style&index=0&id=c53cfe88&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53cfe88"]])

export default __exports__